import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, Immobilie, Vorbelegungen } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { RsActions } from '../rsActions';

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
): Vorbelegungen {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      if (action.payload.appId !== App.RS) {
        return sectionState;
      }

      const immobilie: Immobilie = action.payload.immobilie;
      return {
        adresseImmobilieVorbelegt: immobilie.id !== null,
        versicherungsnehmerVorbelegt: sectionState.versicherungsnehmerVorbelegt,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        versicherungsnehmerVorbelegt: true,
        adresseImmobilieVorbelegt: true,
      };
    }
    case RsActions.PLZ_CHANGED: {
      return {
        ...sectionState,
        adresseImmobilieVorbelegt: false,
      };
    }
    default:
      return sectionState;
  }
};
